import React from 'react';

import { styled, useTheme, Theme, CSSObject } from '@mui/material/styles';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import CssBaseline from '@mui/material/CssBaseline';
import useScrollTrigger from '@mui/material/useScrollTrigger';
import Typography from '@mui/material/Typography';
import Container from '@mui/material/Container';
import Slide from '@mui/material/Slide';

import Divider from '@mui/material/Divider';
import IconButton from '@mui/material/IconButton';
import MenuIcon from '@mui/icons-material/Menu';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';

import logo from './logo.svg';
import { Counter } from './features/counter/Counter';
import { Routes, Route, Link, Outlet } from 'react-router-dom';
import { Home } from './home/page';
import DrawerContent from './app/DrawerContent';
import RightBox from './features/appbar/RightBox';
import AppInit from './AppInit';
import './App.css';

interface Props {
	/**
	 * Injected by the documentation to work in an iframe.
	 * You won't need it on your project.
	 */
	//window?: () => Window;
	children?: React.ReactElement<any>;
}

function HideOnScroll(props: Props) {
	const { children } = props;
	const trigger = useScrollTrigger({});
	return (
		<Slide appear={false} direction="down" in={!trigger}>
			{children ?? <div />}
		</Slide>
	)
}

/*
const contentStyle = {
	height: `calc(100% - 49px)`,
	width: '100%',
	//backgroundColor: 'red',
};
// */


export function App() {
	const theme = useTheme();

	return (
		<Box sx={{ display: 'flex', height: '100vh', margin: 0}}>
			<CssBaseline />
			<Outlet />
		</Box>
	);
}

//export default App;


export default function HideAppBar(props: Props) {
  return (
    <React.Fragment>
      <CssBaseline />
      <HideOnScroll {...props}>
        <AppBar>
          <Toolbar>
            <Typography variant="h6" component="div">
              ScrollHideAppBar
            </Typography>
				<Link to={"/"}>
					<Button sx={{ color: '#fff' }}>
						Home
					</Button>
				</Link>
				<Link to={"/login"}>
					<Button sx={{ color: '#fff' }}>
						Login
					</Button>
				</Link>
          </Toolbar>
        </AppBar>
      </HideOnScroll>
      <Toolbar />
      <Container sx={{padding: 0}}>
        <Box sx={{ my: 2 }}>
			<Outlet />
        </Box>
      </Container>
    </React.Fragment>
  );
}
